module.exports = __webpack_public_path__ + "img/it.6be8ffa8.svg";